// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var inputBase = "w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150 bg-white";

var selectBase = inputBase + " cursor-pointer";

var labelBase = "block text-sm font-medium text-gray-700 mb-1.5";

var hintClass = "text-xs text-gray-500 leading-snug mt-1.5";

var previewBoxClass = "rounded-lg bg-antiflashwhite border border-gray-200 px-3 py-2";

var validationErrorClass = "text-xs text-red-600 mt-1";

var validationWarningClass = "text-xs text-amber-700 mt-1";

exports.inputBase = inputBase;
exports.selectBase = selectBase;
exports.labelBase = labelBase;
exports.hintClass = hintClass;
exports.previewBoxClass = previewBoxClass;
exports.validationErrorClass = validationErrorClass;
exports.validationWarningClass = validationWarningClass;
/* No side effect */
